import React from 'react';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import InlineDateField from './InlineDateField';

interface DateFieldProps {
  slug: string;
}

export default function DateField({ slug }: DateFieldProps): JSX.Element {
  const { values, setFieldValue } = useFormikContext<Record<string, any>>();
  const { t } = useTranslation('pageForm');

  return (
    <InlineDateField
      value={(values[slug] as string) || ''}
      onChange={(next) => setFieldValue(slug, next)}
      placeholderText={t('edit.datePlaceholder')}
    />
  );
}
